import React from "react";
import ServiceItem from "./ServiceItem";
import ServiceProgressArea from "./ServiceProgressArea";
import { Link } from "react-router-dom";
import HomeData from "../../../data/home.json";
function ServiceWrap() {
  const scrollTop = () => window.scrollTo({ top: 0, behavior: "smooth" });
  return (
    <>
      <div className="service-section pt-120 pb-120">
        <div className="container">
          <div className="row mb-4 pb-3 d-flex justify-content-lg-start justify-content-center align-items-center">
            <div className="col-lg-8  text-lg-start text-center">
              <div
                className="section-title2 wow animate fadeInDown"
                data-wow-duration="1.5s"
                data-wow-delay="0.5s"
              >
                <h2 className="cusm-front" >Our Services</h2>
               
              </div>
            </div>

          </div>

          <div className="row d-flex justify-content-center g-4"> 

          <Link to="/managed-service-provider">
<div className="service-item  light-mode hover-btn row g-3 service-intro-row mt-5">


<div className="col-md-5 col-sm-5">
    <img
      style={{ height: "100%;", width: "100%" }}
      src={
        process.env.PUBLIC_URL + "./images/bg/graphic_0001_virtual-finance.png"
      }
      alt="images"
    />
  </div>
  <div className="col-md-7 col-sm-6 ">
    <h3
      style={{ color: "#cf2534", textAlign: "initial" }}
      className=" cusm-front  text-just"
    >
     Managed Service Provider
    </h3>


    <p className="para mt-md-2 color-black cusm-front text_jus cusm-lineheight">
    Many service providers ensure that your call will be returned as soon as possible—but by whom? At Genius Fixers, we provide a US-based support desk manned by qualified technicians (not call agents) who can typically resolve issues right away. Additionally, we allow you to “self-triage” any issue, so you can contact us 24/7/365 for any issue, no matter how big or small. A managed service provider offers great IT help desk solutions, so be sure you’re receiving the best! Distance IT Support End-user problems, like being unable to connect to the internet, having a slow or “frozen” computer, forgetting passwords, being unable to print, or having trouble signing in, are the ones that require tech help the most frequently. These IT issues can be resolved remotely by our team using tools that give us complete access to your network and systems. In order to keep your workforce functioning cost-effectively, Genius Fixers offers remote support technology services that include software installation, cloud services, sophisticated troubleshooting and repairs of apps, and more.
    </p>




  </div>


  



</div>
</Link>



          </div>


          {/* MOBILE  */}
          <div className="row d-flex justify-content-center g-4">

            <div className="service-item  light-mode hover-btn row g-3 service-intro-row mt-5">


              <div className="col-md-7 col-sm-6 ">
                <h3
                  style={{ color: "#cf2534", textAlign: "initial" }}
                  className=" cusm-front  text-just"
                >
UI/UX and Graphics
                </h3>


                <p className="para mt-md-2 color-black cusm-front text_jus cusm-lineheight">
                At Genius Fixers, we understand that creating a visually appealing and user-friendly interface is crucial for the success of any digital product. That's why we offer top-notch UI/UX and graphics services to help you achieve your goals. We specialize in creating custom designs that are tailored to your brand's unique style and identity, ensuring that your product stands out from the competition. Whether you need a new website, mobile app, or software interface, we've got you covered. Our team will work with you every step of the way to ensure that your vision is realized and that your product is a success

                </p>




              </div>

              <div className="col-md-5 col-sm-5">
                <img
                  style={{ height: "100%;", width: "100%" }}
                  src={
                    process.env.PUBLIC_URL + "./images/bg/ui-us-and-graphics.png"
                  }
                  alt="images"
                />
              </div>


            </div>




          </div>

          {/* WEB */}
          <div className="row d-flex justify-content-center g-4"> 

<div className="service-item  light-mode hover-btn row g-3 service-intro-row mt-5">

<div className="col-md-5 col-sm-5">
    <img
      style={{ height: "100%;", width: "100%" }}
      src={
        process.env.PUBLIC_URL + "./images/bg/digital-marketing-&-seo.png"
      }
      alt="images"
    />
  </div>
  <div className="col-md-7 col-sm-6 ">
    <h3
      style={{ color: "#cf2534", textAlign: "initial" }}
      className=" cusm-front  text-just"
    >
     Digital Marketing & SEO 
    </h3>


    <p className="para mt-md-2 color-black cusm-front text_jus cusm-lineheight">
    At Genius Fixers, we offer top-notch digital marketing and SEO services to help businesses improve their online visibility, drive targeted traffic, and boost conversions. Our team of experts utilizes the latest tools and techniques to create customized digital marketing strategies that cater to the specific needs of our clients. From keyword research and on-page optimization to link building and social media marketing, we ensure that every aspect of your online presence is optimized for success. With our data-driven approach and transparent reporting, you can trust that your digital marketing campaigns are in good hands. Contact us today to learn more about how we can help your business grow.
    </p>




  </div>
  



</div>




          </div>

          {/* BLOCK */}
          <div className="row d-flex justify-content-center g-4">

<div className="service-item  light-mode hover-btn row g-3 service-intro-row mt-5">


  <div className="col-md-7 col-sm-6 ">
    <h3
      style={{ color: "#cf2534", textAlign: "initial" }}
      className=" cusm-front  text-just"
    > 
    DevOps Services
    </h3>


    <p className="para mt-md-2 color-black cusm-front text_jus cusm-lineheight">
    Genius Fixers is a top IT company providing cutting-edge DevOps services to help businesses achieve their digital transformation goals. Our DevOps experts collaborate closely with development and operations teams to streamline software delivery processes and automate infrastructure management, resulting in faster time-to-market and higher quality software products. We offer a wide range of DevOps services, including continuous integration and delivery, infrastructure as code, containerization, and cloud-native application development. With our expertise in DevOps, we help businesses stay ahead of the competition and succeed in today's rapidly evolving digital landscape. Contact us today to learn more about our DevOps services and how we can help you achieve your business objectives. 

    </p>




  </div>

  <div className="col-md-5 col-sm-5">
    <img
      style={{ height: "100%;", width: "100%" }}
      src={
        process.env.PUBLIC_URL + "./images/bg/devops-services.png"
      }
      alt="images"
    />
  </div>


</div>




          </div>

          {/*  SASS */}
          <div className="row d-flex justify-content-center g-4"> 

<div className="service-item  light-mode hover-btn row g-3 service-intro-row mt-5">

<div className="col-md-5 col-sm-5">
    <img
      style={{ height: "100%;", width: "100%" }}
      src={
        process.env.PUBLIC_URL + "./images/bg/offshore-software-developmen.png"
      }
      alt="images"
    />
  </div>
  <div className="col-md-7 col-sm-6 ">
    <h3
      style={{ color: "#cf2534", textAlign: "initial" }}
      className=" cusm-front  text-just"
    >
Offshore Software Development
    </h3>


    <p className="para mt-md-2 color-black cusm-front text_jus cusm-lineheight">
    Genius Fixers is a leading IT company that specializes in providing top-notch offshore software development services to clients worldwide. Our team of highly skilled developers and engineers are dedicated to delivering cutting-edge software solutions that are tailored to meet the specific needs of our clients. Our offshore development services are designed to help businesses reduce costs, increase productivity, and accelerate time-to-market.<br/>  Our offshore software development services include web application development, mobile app development, custom software development, cloud computing, and more. We also offer flexible engagement models, ranging from fixed-price contracts to dedicated development teams, to ensure that we can meet the unique needs of each client. 
    </p>




  </div>
  



</div>




          </div>
          {/* Robotic */}
          <div className="row d-flex justify-content-center g-4">

<div className="service-item  light-mode hover-btn row g-3 service-intro-row mt-5">


  <div className="col-md-7 col-sm-6 ">
    <h3
      style={{ color: "#cf2534", textAlign: "initial" }}
      className=" cusm-front  text-just"
    > 
Software Product Engineering 
    </h3>


    <p className="para mt-md-2 color-black cusm-front text_jus cusm-lineheight">
    Our team of experienced engineers and developers work collaboratively with clients to ensure that the software products we engineer are scalable, reliable, and secure. Our software product engineering services cover a wide range of areas, including product design and development, testing and quality assurance, deployment and integration, and ongoing maintenance and support. We can help you at every stage of your software product development lifecycle, from initial concept to final release and beyond. <br/> Our team is passionate about technology and committed to staying up to date with the latest trends and advancements in the industry. We are dedicated to helping businesses harness the power of technology to achieve their goals and drive growth. 
    </p>




  </div>

  <div className="col-md-5 col-sm-5">
    <img
      style={{ height: "100%;", width: "100%" }}
      src={
        process.env.PUBLIC_URL + "./images/bg/software-product-engineering.png"
      }
      alt="images"
    />
  </div>


</div>




          </div>
          {/* Live */}
          <div className="row d-flex justify-content-center g-4"> 

<div className="service-item  light-mode hover-btn row g-3 service-intro-row mt-5">

<div className="col-md-5 col-sm-5">
    <img
      style={{ height: "100%;", width: "100%" }}
      src={
        process.env.PUBLIC_URL + "./images/bg/e-commerce-market-place-development.png"
      }
      alt="images"
    />
  </div>
  <div className="col-md-7 col-sm-6 ">
    <h3
      style={{ color: "#cf2534", textAlign: "initial" }}
      className=" cusm-front  text-just"
    >
     E-Commerce Market Place Development
    </h3>


    <p className="para mt-md-2 color-black cusm-front text_jus cusm-lineheight">
    Genius Fixers offers comprehensive E-Commerce Market Place Development services to help businesses succeed in the digital age. Our team of experts uses cutting-edge technologies and the latest industry trends to develop custom, scalable, and secure marketplaces that meet your specific needs. Whether you are a startup or an established business, we provide end-to-end solutions from consultation, design, development, testing, deployment, and maintenance. Our services include building multi-vendor marketplaces, B2B and B2C marketplaces, mobile apps, payment gateways, and integrating with third-party tools like CRM and ERP. With Genius Fixers, you can increase your online sales, enhance customer experience, and achieve your business goals.  
    </p>




  </div>
  



</div>




          </div>



          {/* CLOUD */}
          <div className="row d-flex justify-content-center g-4">

<div className="service-item  light-mode hover-btn row g-3 service-intro-row mt-5">


  <div className="col-md-7 col-sm-6 ">
    <h3
      style={{ color: "#cf2534", textAlign: "initial" }}
      className=" cusm-front  text-just"
    > 
Digital Transformation Services
    </h3>


    <p className="para mt-md-2 color-black cusm-front text_jus cusm-lineheight">
    Genius Fixers is a leading IT company that offers Digital Transformation services to businesses of all sizes. Our team of experts understands that Digital Transformation is not just about implementing new technologies, but it's about fundamentally changing the way a business operates.  Our Digital Transformation services include everything from Cloud Computing and Big Data Analytics to Artificial Intelligence and Internet of Things (IoT) solutions. We work closely with our clients to understand their unique business needs and develop custom solutions that align with their goals.  With our Digital Transformation services, businesses can optimize their operations, improve productivity, and drive growth in the digital age. Contact us today to learn more about how we can help your business transform digitally!

    </p>




  </div>

  <div className="col-md-5 col-sm-5">
    <img
      style={{ height: "100%;", width: "100%" }}
      src={
        process.env.PUBLIC_URL + "./images/bg/digital-transformation-services.png"
      }
      alt="images"
    />
  </div>


</div>




          </div>


          {/* DATA SCIENCE  */}
          <div className="row d-flex justify-content-center g-4"> 

<div className="service-item  light-mode hover-btn row g-3 service-intro-row mt-5">

<div className="col-md-5 col-sm-5">
    <img
      style={{ height: "100%;", width: "100%" }}
      src={
        process.env.PUBLIC_URL + "./images/bg/data-science-consulting.png"
      }
      alt="images"
    />
  </div>
  <div className="col-md-7 col-sm-6 ">
    <h3
      style={{ color: "#cf2534", textAlign: "initial" }}
      className=" cusm-front  text-just"
    >
IT Staff Augmentation/ Managed Services 
    </h3>


    <p className="para mt-md-2 color-black cusm-front text_jus cusm-lineheight">
    Genius Fixers is a trusted IT company that provides top-notch IT staff augmentation and managed services. Our team of skilled IT professionals can seamlessly integrate into your organization to enhance your technology capabilities. With our staff augmentation services, you can quickly fill skill gaps, meet project deadlines, and scale your team as needed. Our managed services offer a comprehensive solution to your IT needs, including 24/7 monitoring, proactive maintenance, and support. We pride ourselves on delivering customized solutions tailored to your business needs, enabling you to focus on your core operations while we handle your technology needs. Choose Genius Fixers for reliable and efficient IT solutions.
    </p>




  </div>
  



</div>




          </div>


        {/* Virtual Reality */}
        <div className="row d-flex justify-content-center g-4">

<div className="service-item  light-mode hover-btn row g-3 service-intro-row mt-5">


  <div className="col-md-7 col-sm-6 ">
    <h3
      style={{ color: "#cf2534", textAlign: "initial" }}
      className=" cusm-front  text-just"
    > 
Bluetooth (BLE) App Development 
    </h3>


    <p className="para mt-md-2 color-black cusm-front text_jus cusm-lineheight">
    At Genius Fixers, we provide top-notch Bluetooth Low Energy (BLE) app development services to help businesses connect their devices seamlessly. We use the latest tools and technologies to develop BLE apps that are reliable, secure, and user-friendly. Our team will work closely with you to understand your requirements and deliver a solution that exceeds your expectations. <br/> We are committed to delivering high-quality BLE app development services that help our clients achieve their business goals. Contact us today to learn more about our services and how we can help you leverage the power of Bluetooth technology for your business.
    </p>




  </div>

  <div className="col-md-5 col-sm-5">
    <img
      style={{ height: "100%;", width: "100%" }}
      src={
        process.env.PUBLIC_URL + "./images/bg/bluetooth-app-development.png"
      }
      alt="images"
    />
  </div>


</div>




        </div>

        {/* SQA */}
        <div className="row d-flex justify-content-center g-4"> 

<div className="service-item  light-mode hover-btn row g-3 service-intro-row mt-5">

<div className="col-md-5 col-sm-5">
    <img
      style={{ height: "100%;", width: "100%" }}
      src={
        process.env.PUBLIC_URL + "./images/bg/virtual-cto.png"
      }
      alt="images"
    />
  </div>
  <div className="col-md-7 col-sm-6 ">
    <h3
      style={{ color: "#cf2534", textAlign: "initial" }}
      className=" cusm-front  text-just"
    >
Virtual CTO 
    </h3>


    <p className="para mt-md-2 color-black cusm-front text_jus cusm-lineheight">
    Genius Fixers is an IT company that provides top-notch Virtual CTO services to businesses of all sizes. Our team of experienced and highly skilled Virtual CTOs will work with you to understand your business goals and create a technology roadmap that aligns with those goals. <br/>Our Virtual CTOs are also available to provide ongoing support and guidance, helping you to stay on top of the latest technology trends and innovations. With our Virtual CTO services, you can rest assured that your technology investments are in safe hands, and that your business is poised for growth and success in today's digital world. Contact us today to learn more about our Virtual CTO services and how we can help your business achieve its technology goals.
    </p>




  </div>
  



</div>




        </div>

        {/* IOT */}
        <div className="row d-flex justify-content-center g-4">

<div className="service-item  light-mode hover-btn row g-3 service-intro-row mt-5">


  <div className="col-md-7 col-sm-6 ">
    <h3
      style={{ color: "#cf2534", textAlign: "initial" }}
      className=" cusm-front  text-just"
    > 
Google Ads & Facebook Ads
    </h3>


    <p className="para mt-md-2 color-black cusm-front text_jus cusm-lineheight">
    Genius Fixers is a leading IT company that provides expert Google Ads and Facebook Ads services to businesses of all sizes. Our team of experienced digital marketing professionals uses data-driven strategies to help clients achieve their marketing goals and maximize their ROI. With our Google Ads services, we can help you reach your target audience with precision and efficiency, using advanced targeting options and optimization techniques. And with our Facebook Ads services, we can help you create compelling ads that engage your audience and drive conversions. Contact us today to learn more about how we can help you grow your business with our Google Ads and Facebook Ads services.

    </p>




  </div>

  <div className="col-md-5 col-sm-5">
    <img
      style={{ height: "100%;", width: "100%" }}
      src={
        process.env.PUBLIC_URL + "./images/bg/google-ads-&-facebook-ads.png"
      }
      alt="images"
    />
  </div>


</div>




        </div>

        </div>

      </div>
    </>
  );
}

export default ServiceWrap;
